import { ArrayUtils, Encoder, MGPOptional, Utils } from '@everyboard/lib';
import { Coord, CoordFailure } from '../../jscaip/Coord';
import { HexaDirection } from '../../jscaip/HexaDirection';
import { MoveCoord } from '../../jscaip/MoveCoord';
export class AbaloneMove extends MoveCoord {
    dir;
    lastPiece;
    static encoder = Encoder.tuple([Coord.encoder, HexaDirection.encoder, MGPOptional.getEncoder(Coord.encoder)], (m) => [m.coord, m.dir, m.lastPiece], (fields) => new AbaloneMove(fields[0], fields[1], fields[2]));
    static ofSingleCoord(coord, dir) {
        Utils.assert(coord.isInRange(9, 9), CoordFailure.OUT_OF_RANGE(coord));
        return new AbaloneMove(coord, dir, MGPOptional.empty());
    }
    static ofDoubleCoord(first, second, dir) {
        const coords = [first, second];
        ArrayUtils.sortByDescending(coords, AbaloneMove.sortCoord);
        const direction = coords[1].getDirectionToward(coords[0]).get();
        const hexaDirectionOptional = HexaDirection.factory.fromDelta(direction.x, direction.y);
        Utils.assert(hexaDirectionOptional.isSuccess(), 'Invalid direction'); // Should be ensured by component
        const hexaDirection = hexaDirectionOptional.get();
        if (hexaDirection.equals(dir)) {
            return AbaloneMove.ofSingleCoord(coords[1], dir);
        }
        else if (hexaDirection.getOpposite().equals(dir)) {
            return AbaloneMove.ofSingleCoord(coords[0], dir);
        }
        return new AbaloneMove(coords[1], dir, MGPOptional.of(coords[0]));
    }
    static sortCoord(coord) {
        return coord.y * 9 + coord.x;
    }
    constructor(coord, dir, lastPiece) {
        super(coord.x, coord.y);
        this.dir = dir;
        this.lastPiece = lastPiece;
    }
    toString() {
        if (this.isSingleCoord()) {
            return 'AbaloneMove(' + this.coord.x + ', ' + this.coord.y + ', ' + this.dir.toString() + ')';
        }
        else {
            return 'AbaloneMove(' + this.coord.toString() + ' > ' + this.lastPiece.get().toString() + ', ' + this.dir.toString() + ')';
        }
    }
    isSingleCoord() {
        return this.lastPiece.isAbsent();
    }
    equals(other) {
        return other.coord.equals(this.coord) &&
            other.dir.equals(this.dir) &&
            other.lastPiece.equals(this.lastPiece);
    }
    isTranslation() {
        return this.lastPiece.isPresent() &&
            this.coord.getDirectionToward(this.lastPiece.get()).get().equals(this.dir) === false;
    }
}
